<template>
	<div class="rightInner">
		<div class="title">
			<div class="titleLine"></div>
			{{$t('mypages.history.title')}}
		</div>
		<table>
			<thead>
					<th>{{$t('mypages.history.th_image')}}</th>
					<th>{{$t('mypages.history.th_brand_name')}}</th>
					<th>{{$t('mypages.history.th_description')}}</th>
					<th>{{$t('mypages.history.th_price')}}</th>
					<th>{{$t('mypages.history.th_view_time')}}</th>
					<th>{{$t('mypages.history.th_action')}}</th>
			</thead>
			<tbody>
				<tr v-for="(item,index) in recordList" :key="item.id">
					<td>
						<div class="tdInner">
							<img :src="item.cover_image" class="proImg"/>
						</div>
					</td>
					<td>
						<div class="tdInner">
							<div>{{item.product_name}}</div>
							<div class="grayText">{{item.cate_name}}</div>
						</div>
					</td>
					<td>
						<div class="tdInner">
							{{item.short_intro}}
						</div>
					</td>
					<td>
						<div class="tdInner redText center">￥{{item.sale_price==null?0:item.sale_price}}</div>
					</td>
					<td>
						<div class="tdInner center">{{item.gmt_record}}</div>
					</td>
					<td>
						<div class="tdInner center">
							<div class="addCar" @click="goBuy(item.id)">{{$t('mypages.history.add_to_cart')}}</div>
							<div class="cancel" @click="Delete(item.record_id)">{{$t('mypages.history.delete')}}</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="paginationArea"><PaginationVue  :TotalCount="totalcount" :pageSize="10" @pageChenged="handlePage"></PaginationVue></div>
	</div>
</template>

<script>
	import PaginationVue from '../../components/pagination.vue';
	export default{
		components:{
			PaginationVue
		},
		data(){
			return {
				recordList:[],
				pageIndex:1,
				totalcount:1,
			}
		},
		created()
		{
			this.getRecordList();
		},
		methods:{			
			getRecordList() {
				this.recordList=[];
				this.$scUtil.axiosPut(this, 'RecordApi/GetRecordList', {
					pageIndex: this.pageIndex,
					pageSize:10,
					userName: localStorage.getItem('username'),
				}, res => {
					if (res.code == 100) {
						res.data.forEach(item => {
						    item.gmt_record=this.$scUtil.dateFormatter(new Date(item.gmt_record), 'Y-M-D');
						});
						this.recordList=res.data;
						this.totalcount=res.totalcount;
						//console.log("浏览历史:"+JSON.stringify(this.recordList))
					}
			
				});
			},
			handlePage(message) {
				console.log(message);
				this.pageIndex = message;
				this.getRecordList();
			},
			goBuy(id)
			{
				this.$router.push({name:'DetailVue',query:{id:id}})
			},
			Delete(id)
			{
					this.$confirm(this.$t('mypages.history.confirm_delete_msg'), this.$t('mypages.history.confirm_title'), {
					        distinguishCancelAndClose: true,
					        confirmButtonText: this.$t('mypages.history.confirm_ok'),
					        cancelButtonText: this.$t('mypages.history.confirm_cancel'),
					        type: 'warning'
					      }).then(() => {
				         try 
						 {
								this.$scUtil.axiosPost(this, 'RecordApi/Delete', {
									id:id
								}, res => {
				         		if (res.code == 100) {
				         			this.$message({
				         				message: res.message,
				         				type: "success"
				         			});
									this.getRecordList();
				         			return;
				         		}
				         
				         	});
				         } catch (error) {
				         	console.log(error);
				         }
				      }).catch(action => {
				        // 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
						console.log(action)
				        if (action == 'cancel'||action=='close') {
							console.log("执行了吗")
				          this.getRecordList();
				        }
				})
			}
		},
	}
	
</script>

<style scoped>
	.rightInner{
		width: 958px;	
	}
	
	
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
		background-color:#fff;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #db050f;
		margin-right: 15px;
	}
	
	
	.proImg{
		width: 78px;
		height: 76px;
		border: 1px solid #e9e9e9;
	}
	
	table{
		border-collapse: collapse;
		width: 100%;
	}
	
	table thead th{
		background-color: #fff;
		border-bottom: 13px solid #ebecee;
		height: 52px;
		line-height: 52px;
		font-size: 12px;
		color: #000000;
	}
	
	table tbody tr td{
		color: #333;
		font-size: 13px;
		background-color: #fff;
		padding: 20px;
		box-sizing: border-box;
		min-width: 130px;
		line-height: 25px;
		border-bottom: 1px solid #e2e2e2;
	}
	
	.grayText{
		font-size: 12px;
		color: #888888;
	}
	
	.redText{
		color: #db050f;
	}
	
	.addCar{
		width: 82px;
		height: 26px;
		border: 1px solid #0380fe;
		color: #0380fe;
		font-size: 12px;
		cursor: pointer;
		text-align: center;
		line-height: 26px;
	}

	.cancel{
		color: #666;
		font-size: 12px;
		cursor: pointer;
	}
	
	table tbody tr td .center{
		text-align: center;
	}
	
	.paginationArea{
		display: flex;
		justify-content: center;
		background-color: #fff;
		padding: 17px 0;
	}
	
</style>